export class Config {
  readonly session_ttl_days = 1;
  readonly timer_interval_minutes = 1;
}
